module.exports = __webpack_public_path__ + "static/img/plant.6b473a4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lottie/plant.gif
// module id = Ikuc
// module chunks = 262